import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=5bc7afb7&scoped=true"
import script from "./Form.ts?vue&type=script&lang=ts&external"
export * from "./Form.ts?vue&type=script&lang=ts&external"
import style0 from "./Form.vue?vue&type=style&index=0&id=5bc7afb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7afb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc7afb7')) {
      api.createRecord('5bc7afb7', component.options)
    } else {
      api.reload('5bc7afb7', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=5bc7afb7&scoped=true", function () {
      api.rerender('5bc7afb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Forms/components/Form/Form.vue"
export default component.exports